import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-pending-approval-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfPendingApprovalIconProps extends SvgIconProps  {}

/**
 *This icon is used to displayed on notification message for pending approval of email
 * @param props - CcfPendingApprovalIconProps
 * @example <CcfPendingApprovalIcon />
 * @returns
 */
export function CcfPendingApprovalIcon(props: CcfPendingApprovalIconProps) {
  return (
    <SvgIcon
      {...props}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.379 11.0996C20.379 12.9785 19.8219 14.8153 18.778 16.3775C17.7341 17.9398 16.2504 19.1574 14.5145 19.8765C12.7786 20.5955 10.8685 20.7836 9.02567 20.4171C7.18285 20.0505 5.49012 19.1457 4.16152 17.8171C2.83292 16.4885 1.92813 14.7958 1.56157 12.953C1.19501 11.1101 1.38314 9.20002 2.10218 7.46412C2.82121 5.72822 4.03885 4.24452 5.60112 3.20065C7.16338 2.15677 9.00011 1.59961 10.879 1.59961C12.1266 1.59961 13.3619 1.84533 14.5145 2.32275C15.6671 2.80017 16.7144 3.49994 17.5965 4.38209C18.4787 5.26425 19.1785 6.31152 19.6559 7.46412C20.1333 8.61671 20.379 9.85205 20.379 11.0996V11.0996Z"
        stroke="#006398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.879 5.32764V11.9996L15.144 14.0826"
        stroke="#006398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default CcfPendingApprovalIcon;
